var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "grid-container" }, [
    _c("div", [
      _c(
        "button",
        {
          staticClass: "btn btn-primary",
          attrs: { disabled: _vm.loading },
          on: {
            click: function($event) {
              return _vm.$emit("get-queue")
            }
          }
        },
        [
          _c("i", { staticClass: "fa fa-refresh" }),
          _vm._v(" " + _vm._s(_vm.resource("Button_Refresh")) + "\n        ")
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", [
      _c("b", [
        _vm._v(_vm._s(_vm.resource("AnalysisSelection_Index_TotalTime_Label")))
      ]),
      _vm._v(" " + _vm._s(_vm.totalTimeString)),
      _c("br"),
      _vm._v(" "),
      _c("b", [
        _vm._v(
          _vm._s(_vm.resource("AnalysisSelection_Index_SelectedTime_Label"))
        )
      ]),
      _vm._v(" " + _vm._s(_vm.selectedTimeString) + "\n    ")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "grid-item-bottom-right" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-danger",
          attrs: { disabled: _vm.loading || _vm.selectedTime === 0 },
          on: {
            click: function($event) {
              return _vm.clearQueue()
            }
          }
        },
        [
          _c("i", { staticClass: "fas fa-trash-alt" }),
          _vm._v(
            " " +
              _vm._s(
                _vm.resource(
                  "AnalysisSelection_Index_Button_ClearQueue_DisplayName"
                )
              ) +
              "\n        "
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "grid-item-bottom-right" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-success",
          attrs: { disabled: _vm.loading || _vm.selectedTime === 0 },
          on: {
            click: function($event) {
              return _vm.startAnalysis()
            }
          }
        },
        [
          _c("i", { staticClass: "fas fa-play" }),
          _vm._v(
            " " +
              _vm._s(
                _vm.resource(
                  "AnalysisSelection_Index_Button_StartAnalysis_DisplayName"
                )
              ) +
              "\n        "
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }